<template>
    <div class="form-contact">
        <mu-paper :z-depth="1">

            <mu-form :model="form">

                <mu-row gutter>
                    <mu-col span="12" sm="12" md="8" lg="8" xl="8">

                        <mu-row gutter>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- Nome -->
                                <mu-text-field v-model="form.firstname" full-width label="Nome"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- Sobrenome -->
                                <mu-text-field v-model="form.lastname" full-width label="Sobrenome"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- Telefone -->
                                <mu-text-field v-model="form.phone" v-mask="['(##) ####-####', '(##) #####-####']" full-width label="Telefone *"></mu-text-field>
                            </mu-col>
                            <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                                <!-- Data de Aniversário -->
                                <mu-text-field v-model="form.birthday" v-mask="'##/##/####'" full-width label="Data de Aniversário"></mu-text-field>
                            </mu-col>
                        </mu-row>

                        <!-- Status -->
                        <mu-select label="Status" v-model="form.status" full-width>
                            <mu-option v-for="(option, key) in options.status" :key="key" :label="option.label" :value="option.value"></mu-option>
                        </mu-select>

                        <!-- Contato bloqueado -->
                        <mu-form-item prop="checkbox" class="black-list">
                            <mu-checkbox v-model="form.blacklist" value="2" label="Contato bloqueado"></mu-checkbox>
                        </mu-form-item>

                    </mu-col>
                    <mu-col span="12" sm="12" md="4" lg="4" xl="4">

                        <!-- Grupos -->
                        <div class="groups">
                            <mu-button full-width large color="secondary" @click="handleGroupsDialog(true)">
                                Selecione os grupos
                            </mu-button>
                            <mu-divider></mu-divider>
                            <div v-if="groups.list == null || groups.list.length == 0">
                                <div class="alert">
                                    <font-awesome-icon icon="exclamation-triangle" class="icon-big"/>
                                    <p>Não existe grupos selecionados para este contato. Clique no botão acima e selecione pelo menos 1 (um) dos grupos.</p>
                                </div>
                            </div>
                            <div class="groups-scroll" v-if="groups.list.length > 0">
                                <table class="mu-table">
                                    <thead>
                                        <tr>
                                            <th>Selecionados</th>
                                            <th class="is-center">Contatos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, key) in groups.list" :key="key">
                                            <td>
                                                <span v-if="item.group_id">
                                                    {{ item.name }}<br>
                                                    <small>Grupo: {{ item.group.name }}</small>
                                                </span>
                                                <span v-else>
                                                    {{ item.name }}
                                                </span>
                                            </td>
                                            <td class="is-center">{{ item.totalcontacts }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </mu-col>
                </mu-row>

                <!-- Diálogo com a listagem dos grupos da empresa -->
                <mu-dialog width="500" :open.sync="groups.open">
                    <div class="dialog-groups">
                        <h3>Selecione os Grupos / Subgrupos do contato</h3>
                        <div class="dialog-box-search">
                            <font-awesome-icon icon="search" />
                            <input type="text" v-model="groups.filter" placeholder="_ Filtre os grupos e subgrupos">
                        </div>
                        <div class="dialog-box-scroll">
                            <table class="mu-table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Nome</th>
                                        <th class="is-center">Contatos</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, key) in groupsFilter" :key="key">
                                        <td class="is-center"><mu-checkbox  :value="item" v-model="groups.list"></mu-checkbox></td>
                                        <td>
                                            <span v-if="item.group_id">
                                                {{ item.name }}<br>
                                                <small>Grupo: {{ item.group.name }}</small>
                                            </span>
                                            <span v-else>
                                                {{ item.name }}
                                            </span>
                                        </td>
                                        <td class="is-center">{{ item.totalcontacts }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <mu-button slot="actions" round color="primary" @click="handleGroupsDialog(false)">
                        <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                        Ok
                    </mu-button>
                </mu-dialog>

                <!-- Salvar -->
                <mu-flex class="actions">
                    <mu-button round color="primary" @click="saveForm()" :disabled="!form.phone">
                        <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                        Salvar
                    </mu-button>
                    <mu-button round :to="{ name: 'app.contacts.contacts' }">
                        Cancelar
                    </mu-button>
                </mu-flex>

            </mu-form>

        </mu-paper>

        <br>

        <!-- Bloco para excluir o contato -->
        <mu-paper class="cancel" :z-depth="1" v-if="type == 'edit'">

            <!-- Pergunta para excluir o contato  -->
            <mu-row class="user-cost" justify-content="center" align-items="center">
                <mu-col span="12" sm="12" md="8" lg="8" xl="8">
                    <mu-flex class="title" justify-content="start" align-items="center">
                        <font-awesome-icon icon="exclamation-triangle" class="icon-md icon-margin-left color-red"/>
                        <strong>Excluir contato</strong>
                    </mu-flex>
                    Todos os dados deste contato serão perdidos e não terá como voltar.
                </mu-col>
                <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                    <div class="text-right">
                        <mu-button round color="error" @click="handleDialogDelete(true)">
                            <font-awesome-icon icon="trash" class="icon-md icon-margin-left"/>
                            Excluir
                        </mu-button>
                    </div>
                </mu-col>
            </mu-row>

            <!-- Dialogo para confirmar exclusão de campanha -->
            <mu-dialog title="Excluir o contato" width="600" max-width="80%" :esc-press-close="false" :overlay-close="false" :open.sync="cancel.openDelete">
                Tem certeza que deseja excluir o usuário <strong>{{ form.firstname }} {{ form.lastname }}</strong>
                <mu-button slot="actions" round @click="handleDialogDelete(false)">Cancelar</mu-button>
                <mu-button slot="actions" round color="error" @click="deleteForm()">
                    <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                    Confirmar
                </mu-button>
            </mu-dialog>

        </mu-paper>

    </div>
</template>

<script>
    import moment from 'moment'
    import { mask } from 'vue-the-mask'
    import ContactsServices from '@/services/contacts/contacts'
    import GroupsServices from '@/services/contacts/groups'

    export default {
        name: 'mu-form-contact',

        // ╔═╗╦═╗╔═╗╔═╗╔═╗
        // ╠═╝╠╦╝║ ║╠═╝╚═╗
        // ╩  ╩╚═╚═╝╩  ╚═╝
        props: ['type'],

        // ╔╦╗╦╦═╗╔═╗╔═╗╔╦╗╦╦  ╦╔═╗╔═╗
        //  ║║║╠╦╝║╣ ║   ║ ║╚╗╔╝║╣ ╚═╗
        // ═╩╝╩╩╚═╚═╝╚═╝ ╩ ╩ ╚╝ ╚═╝╚═╝
        directives: { mask },

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                options: {
                    groups: [],
                    status: [
                        { label: 'Inativo', value: 'I' },
                        { label: 'Ativo', value: 'A' }
                    ]
                },
                groups: {
                    open: false,
                    filter: '',
                    list: []
                },
                form: {
                    birthday: '',
                    status: 'A',
                    blacklist: false,
                    subscribed: true,
                    groups: []
                },
                cancel: {
                    openDelete: false
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {
            groupsFilter () {
                return this.options.groups.filter((item) => {
                    return item.name.toLowerCase().includes(this.groups.filter.toLowerCase()) || (item.group && item.group.name.toLowerCase().includes(this.groups.filter.toLowerCase()))
                })
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        async mounted () {
            // Carrega os grupos
            await this.loadGroups()

            // Carrega os dados do contato se for edição
            if (this.type === 'edit') {
                this.loadForm()
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝
        methods: {

            /**
             * Carrega a listagem de grupos do cliente
             */
            async loadGroups () {
                try {
                    let result = await GroupsServices.all()

                    if (result && result.status) {
                        this.options.groups = result.results
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', 'Não foi possível carregar a lista de grupos.')
                }
            },

            /**
             * Carrega os dados do contato
             */
            async loadForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando os dados do contato.')

                    this.form = {}

                    let result = await ContactsServices.find(this.$route.params.id)

                    if (result && result.status) {
                        this.form = result.results
                        this.form.birthday = this.form.birthday ? this.dateFormat(this.form.birthday) : ''
                        this.form.groups = this.form.groups ? this.formatGroups(this.form.groups) : []
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Salva os dados do formulário
             */
            async saveForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Salvando os dados do contato.')

                    let clone = Object.assign({}, this.form)
                    let data = await this.treatment(clone)

                    if (data.birthday && !moment(data.birthday).isValid()) {
                        this.$eventHub.$emit('snackbar', 'error', `A data de aniversário ${this.form.birthday} não é valida`, false)
                        return
                    }

                    let result
                    if (this.type === 'edit') {
                        result = await ContactsServices.update(data)
                    } else {
                        result = await ContactsServices.store(data)
                    }

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.$router.push({ name: 'app.contacts.contacts' }).catch(err => { if (err) console.log(err.name || '') })
                        return
                    } else if (result && result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar o contato.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Responsável por excluir o contato
             */
            async deleteForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde, o contato está sendo excluído.')

                    let result = await ContactsServices.destroy(this.form.id)

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.$router.push({ name: 'app.contacts.contacts' }).catch(err => { if (err) console.log(err.name || '') })
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível excluir o contato.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Habilita ou desabilita o dialog para excluir o contato
             */
            handleDialogDelete (value) {
                this.cancel.openDelete = value
            },

            /**
             * Habilita ou desabilita a listagem de grupos compartilhados
             */
            handleGroupsDialog (value) {
                this.groups.open = value
            },

            /**
             * Faz um tratamento dos dados antes de enviar para API
             */
            async treatment (data) {
                data.phone = await this.treatmentPhoneToNumber(data.phone)
                data.birthday = await this.treatmentDateStringToDate(data.birthday)
                data.groups = await this.groups.list.map((item) => {
                    return {
                        id_groups: item.id
                    }
                })
                return data
            },

            /**
             * Formata os grupos
             */
            formatGroups (groups) {
                this.groups.list = groups.map((item) => {
                    return this.options.groups.find((i) => {
                        return i.id === item.id_groups
                    })
                })
                return groups.map((item) => {
                    return {
                        id_groups: item.id_groups
                    }
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../assets/stylus/bootstrap.styl'

    .form-contact
        margin 20px 0

        .groups
            background lighten($grey, 95%)
            padding 10px
            margin-top 5px
            margin-bottom 15px
            border-radius 3px

            .alert
                color #344b56
                font-size 12px
                line-height 18px
                text-align center
                padding 30px

            .mu-divider
                margin 10px 0

            .mu-chip
                margin 0 5px 5px 0

            .groups-scroll
                height 230px
                overflow hidden
                overflow-y scroll

                span
                    font-weight bold
                    small
                        color #aaa
                        font-weight normal
                        text-transform uppercase

                .mu-table
                    width 100%
                    background none
                    color darken($grey, 30%)
                    tr
                        height auto
                        &:hover
                            background lighten($grey, 70%)
                            color #000
                        th
                            background lighten($grey, 50%)
                            padding 6px 2px 2px 6px
                            font-size 12px
                    td
                        padding 6px 2px 2px 6px
                        font-size 12px

                table, th, td
                    border-collapse collapse

        .mu-paper
            padding 20px

        .actions
            .mu-button
                margin-right 5px

        .cancel
            background lighten(#F44336, 92%)
            padding 20px
            color #999
            border 1px #F44336 dotted

            .title
                i
                    font-size 18px !important
                    color #F44336
                strong
                    font-size 16px
                    padding-left 5px
                    color #F44336

            .text-center
                text-align center

            .text-right
                text-align right

    .dialog-groups

        h3
            margin 10px 0 5px 0
            color $primary

        .dialog-box-search

            margin-bottom 10px

            svg
                position absolute
                margin 12px 0 0 12px
                color $grey

            input
                color $grey
                background lighten($grey, 90%)
                padding 10px 0
                text-indent 40px
                font-size 12px
                width 100%
                border 1px #ddd solid
                border-bottom-width 2px

        .dialog-box-scroll
            height 300px
            overflow hidden
            overflow-y scroll
            border 1px #ddd solid
            span
                font-weight bold
                small
                    color #aaa
                    font-weight normal
                    text-transform uppercase

        .mu-table
            width 100%
            tr
                color #999
                height auto
                &:hover
                    background lighten($primary, 96%)
                    color $primary
                th
                    background lighten($grey, 90%)
                    background $primary
                    padding 6px 2px 2px 6px
                    font-size 12px
                    color #fff
            td
                padding 6px 2px 2px 6px
                font-size 12px

        table, th, td
            border-collapse collapse

</style>
